/* eslint-disable react/no-unknown-property */

import { LoadingType } from '@/common/components/base/Loading/loading.type.ts';
import { token } from 'styled-system/tokens';

const CircularLoading = ({ width = '50px', color }: LoadingType) => {
  const colorValue = token(color);
  return (
    <svg width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
      <radialGradient
        id="a12"
        cx=".66"
        fx=".66"
        cy=".3125"
        fy=".3125"
        gradientTransform="scale(1.5)"
      >
        <stop offset="0" stopColor={colorValue}></stop>
        <stop offset=".3" stopColor={colorValue} stopOpacity=".9"></stop>
        <stop offset=".6" stopColor={colorValue} stopOpacity=".6"></stop>
        <stop offset=".8" stopColor={colorValue} stopOpacity=".3"></stop>
        <stop offset="1" stopColor={colorValue} stopOpacity="0"></stop>
      </radialGradient>
      <circle
        transform-origin="center"
        fill="none"
        stroke="url(#a12)"
        strokeWidth="19"
        strokeLinecap="round"
        strokeDasharray="200 1000"
        strokeDashoffset="0"
        cx="100"
        cy="100"
        r="70"
      >
        <animateTransform
          type="rotate"
          attributeName="transform"
          calcMode="spline"
          dur="1"
          values="360;0"
          keyTimes="0;1"
          keySplines="0 0 1 1"
          repeatCount="indefinite"
        ></animateTransform>
      </circle>
      <circle
        transform-origin="center"
        fill="none"
        opacity=".2"
        stroke={colorValue}
        strokeWidth="19"
        strokeLinecap="round"
        cx="100"
        cy="100"
        r="70"
      ></circle>
    </svg>
  );
};
export default CircularLoading;
